import React from 'react';
import { Typography } from 'antd';
import { ParagraphProps } from 'antd/lib/typography/Paragraph';

export type { ParagraphProps };

const ProTypographyParagraph: React.FC<ParagraphProps> = (props) => {
  const { children, ...resProps } = props;

  return <Typography.Paragraph {...resProps}>{children}</Typography.Paragraph>;
};

export default ProTypographyParagraph;
